import { render, staticRenderFns } from "./DepouillementUpdater.vue?vue&type=template&id=3840c034&scoped=true&"
import script from "./DepouillementUpdater.vue?vue&type=script&lang=ts&"
export * from "./DepouillementUpdater.vue?vue&type=script&lang=ts&"
import style0 from "./DepouillementUpdater.vue?vue&type=style&index=0&id=3840c034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3840c034",
  null
  
)

export default component.exports